// contexts/AuthContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import Swal from 'sweetalert2';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [isContextloading, setIsContextloading] = useState(true);
    const [email, setEmail] = useState(null);

    // ✅ FIX 1: Safely get user data from localStorage
    const getUserData = () => {
        try {
            const storedData = localStorage.getItem('dcs_simulator_user_data');
            if (!storedData) return null;
            
            const parsed = JSON.parse(storedData);
            return parsed?.userData || parsed; // Handle both formats
        } catch (e) {
            console.error('Error parsing user data:', e);
            return null;
        }
    };

    useEffect(() => {
        const checkAdmin = async () => {
            // ✅ First, check sessionStorage cache
            const cached = sessionStorage.getItem('adminStatus');
            if (cached) {
                try {
                    const { isAdmin, timestamp } = JSON.parse(cached);
                    if (Date.now() - timestamp < 10 * 60 * 1000) {
                        setIsAdmin(isAdmin);
                        setIsContextloading(false);
                        return;
                    }
                } catch (e) {
                    sessionStorage.removeItem('adminStatus');
                }
            }

            // ✅ FIX 2: Get token and user data
            let token = localStorage.getItem('token');
            const user = getUserData();

            // ✅ FIX 3: If no token but we have user data, authenticate
            if (!token && user) {
                try {

                    const response = await fetch('https://api.nktechhub.com/api/refinery/authenticate', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(user) // ✅ FIX: Stringify the object!
                    });

                    if (!response.ok) {
                        throw new Error('Failed to authenticate');
                    }

                    const data = await response.json();

                    // ✅ FIX 4: Save the token!
                    if (data.token) {
                        localStorage.setItem('token', data.token);
                        token = data.token; // Update token variable
                    } else {
                        // No token returned - user might not have access
                        console.warn('No token received from authentication');
                        setIsAdmin(false);
                        setIsContextloading(false);
                        return;
                    }
                } catch (error) {
                    console.error('Authentication error:', error);
                    setIsAdmin(false);
                    setIsContextloading(false);
                    return;
                }
            }

            // ✅ If still no token after authentication, user is not logged in
            if (!token) {
                console.log('No token found - user is not authenticated');
                setIsAdmin(false);
                setIsContextloading(false);
                return;
            }

            // ✅ FIX 5: Check admin status with the token
            try {

                const response = await fetch('https://api.nktechhub.com/api/refinery/check-admin', {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`, // ✅ FIX: Uncommented!
                        'Content-Type': 'application/json'
                    }
                });

                if (!response.ok) {
                    throw new Error('Failed to check admin status');
                }

                const data = await response.json();

                setIsAdmin(data.isAdmin || false);

                // ✅ Cache the result
                sessionStorage.setItem('adminStatus', JSON.stringify({
                    isAdmin: data.isAdmin || false,
                    timestamp: Date.now()
                }));
            } catch (error) {
                console.error('Admin check error:', error);
                setIsAdmin(false);
            } finally {
                setIsContextloading(false);
            }
        };

        checkAdmin();
    }, []);

    return (
        <AuthContext.Provider value={{ isAdmin, isContextloading, email }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return context;
};